var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipShow!=1),expression:"tipShow!=1"}],staticClass:"tip_text"},[_vm._v("\n    在您开始浏览数据以及操作以前，请先撰写产品承诺函，加盖贵公司公章后上传文件，上传成功后请等待人工审核，审核通过后方可进行下一步对数据的操作。"),_c('br'),_vm._v("\n    如你在"),_c('span',{staticClass:"str"},[_vm._v("注册后14天内未上传承诺函，我们会将该账号进行回收。")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-37b82c4f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/user/centerTip.vue
// module id = 91ne
// module chunks = 5